
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/today",
      function () {
        return require("private-next-pages/today.tsx");
      }
    ]);
  